module.exports = __webpack_public_path__ + "img/sqfw_icon.6d997460.svg";